import clsx from 'clsx'
import type { ReactNode } from 'react'

import { Icon, type IconName } from '@fv/client-components'

import { HelpHrefButton } from './HelpHrefButton'

type PageProps = {
  title?: ReactNode
  children?: ReactNode
  noBorder?: boolean
  icon?: IconName
  iconClass?: string
  className?: string
  helpHref?: string
  helpText?: string
}

export const PageHeader = ({
  title,
  children,
  noBorder,
  icon,
  iconClass,
  className,
  helpHref,
  helpText,
}: PageProps) => {
  return (
    <h5
      className={clsx(
        noBorder ? 'mb-5' : 'border-b border-fv-gray mb-5 pb-2',
        className,
      )}
    >
      {(title || icon) && (
        <div className="flex items-center gap-x-1">
          {icon && (
            <Icon
              icon={icon}
              className={clsx(' ', iconClass ? iconClass : 'text-inherit')}
            />
          )}
          {title}
        </div>
      )}
      {children}
      {helpHref && <HelpHrefButton href={helpHref} text={helpText} />}
    </h5>
  )
}
